import { connect } from "react-redux";
import { isFeatureActive } from "../../../../state/modules/features";

import Wrapper from "./Wrapper";

function mapStateToProps(state) {
  return {
    isGradientBackground: isFeatureActive(state, "stc-gradient-background")
  };
}

export default connect(mapStateToProps)(Wrapper);



// WEBPACK FOOTER //
// ./template/components/Navigation/LargeSecondaryNavigation/ImageCardsWithDescription/index.js